import Button from "components/components/Button/Button";
import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";
import featureFlags from "utils/featureFlags";

export const QueueInfoContainer = styled.div`
  background-color: ${colours.lightGrey};
  width: 100%;
  margin-bottom: 1.5em;
`;

export const QueueInfoHeader = styled.div`
  background-color: ${colours.elexonBlue};
  color: white;
  padding: 0.3em 0.5em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${fonts.medium};
`;

export const QueueInfoContent = styled.div`
  padding: 0 0.5em 0.5em;
  margin-bottom: 1em;
`;

export const QueueDetailsRow = styled.div`
  font-size: ${fonts.smallMedium};

  && {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .is-child:last-child {
    display: flex;
    justify-content: flex-end;
  }
`;

export const DeleteQueueButton = styled(Button)`
  & {
    background-color: transparent;
    color: ${colours.white};
    border: none;
    border-radius: 0;
    font-size: ${fonts.small};
    font-weight: ${featureFlags.rebrand ? "normal" : "lighter"};
    text-transform: none;
    letter-spacing: 0;
    padding: 0;
    text-underline-offset: 4px;

    &:active {
      box-shadow: none;
    }

    &:hover {
      text-decoration: underline;
      color: ${colours.white};
    }

    &:focus {
      color: ${colours.white};
    }

    &:disabled {
      background-color: transparent;
    }
  }
`;
